import React from "react"
import "./RangeSlider.css"
import Paragraphs from "../Texts/Paragraphs"
const RangeSlider = ({
  value,
  onChange,
  min = 0,
  max = 100,
  title,
  subText,
  containerClass = "",
}) => {
  const handleChange = (event) => {
    onChange(event.target.value)
  }

  return (
    <div className={`mt-[45px] ${containerClass}`}>
      <div className="flex flex-row justify-between mb-[12px] md:mb-[20px]">
        <Paragraphs
          variant="tertiary"
          text={title}
        />
        <span className="text-[14px] md:text-[20px] lg:text-[24px] font-[700] leading-[14.98px] md:leading-[20.84px] lg:leading-[27.84px] text-[#424952]  font-Apparat">
          {subText}
        </span>
      </div>
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
        className="slider"
      />
    </div>
  )
}

export default RangeSlider
